import React from 'react';
import { Card, Typography, Table, Button, Space } from 'antd';
import { BankOutlined, PlusOutlined } from '@ant-design/icons';

const { Title } = Typography;

const CommissionsPage = () => {
  const columns = [
    {
      title: 'Commission ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Client',
      dataIndex: 'client',
      key: 'client',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => `$${amount.toLocaleString()}`,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: () => (
        <Space size="middle">
          <Button type="link" size="small">
            View
          </Button>
          <Button type="link" size="small">
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  // Sample data - replace with actual data from your API
  const data = [];

  return (
    <div>
      <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={2}>
          <BankOutlined style={{ marginRight: 8 }} />
          Commissions
        </Title>
        <Button type="primary" icon={<PlusOutlined />}>
          New Commission
        </Button>
      </div>

      <Card>
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
          }}
          locale={{
            emptyText: 'No commissions found. Click "New Commission" to get started.',
          }}
        />
      </Card>
    </div>
  );
};

export default CommissionsPage;
